import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    language: localStorage.getItem('language'),
    search: null,
    city: localStorage.getItem('city'),
    country: localStorage.getItem('country'),
    lat: Number(localStorage.getItem('lat')),
    lng: Number(localStorage.getItem('lng')),
    distance: null,
    message: '',
    type: '',
    userId: Number(localStorage.getItem('userId')),
    userName: localStorage.getItem('userName'),
    userRoles: localStorage.getItem('userRoles') && localStorage.getItem('userRoles').includes('[') ? JSON.parse(localStorage.getItem('userRoles')) : [],
    userTotalProjects: Number(localStorage.getItem('userTotalProjects')),
    discounted: localStorage.getItem('discounted') ? JSON.parse(localStorage.getItem('discounted')) : false,
    messagesUnread: 0,
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
    store: false,
    orders: localStorage.getItem('orders') ? JSON.parse(localStorage.getItem('orders')) : [],
    shippingDiscount: 6,
    keepLoginBar: false,
    redirected: false,
    previousRoute: '/',
    toRoute: '/',
    scrollPositions: [],
    activeScrollPosition: {
      path: '/',
      x: 0,
      y: 0
    }
  },
  mutations: {
    language: (state, language) => {
      state.language = language
      localStorage.setItem('language', language)
    },
    search: (state, search) => {
      state.search = search
    },
    city: (state, city) => {
      if (city === null) {
        localStorage.removeItem('city')
        state.city = null
      } else {
        state.city = city
        localStorage.setItem('city', city)
      }
    },
    country: (state, country) => {
      if (country === null) {
        localStorage.removeItem('country')
        state.country = null
      } else {
        state.country = country
        localStorage.setItem('country', country)
      }
    },
    lat: (state, lat) => {
      if (lat === null) {
        localStorage.removeItem('lat')
        state.lat = null
      } else {
        state.lat = Number(lat)
        localStorage.setItem('lat', Number(lat))
      }
    },
    lng: (state, lng) => {
      if (lng === null) {
        localStorage.removeItem('lng')
        state.lng = null
      } else {
        state.lng = Number(lng)
        localStorage.setItem('lng', Number(lng))
      }
    },
    distance: (state, distance) => {
      state.distance = distance
    },
    success: (state, message) => {
      state.message = message
      state.type = 'success'
    },
    error: (state, message) => {
      state.message = message
      state.type = 'error'
    },
    warning: (state, message) => {
      state.message = message
      state.type = 'warning'
    },
    clear: (state) => {
      state.message = null
      state.type = null
    },
    userId: (state, userId) => {
      state.userId = userId
      localStorage.setItem('userId', userId)
    },
    userName: (state, userName) => {
      state.userName = userName
      localStorage.setItem('userName', userName)
    },
    userRoles: (state, userRoles) => {
      state.userRoles = userRoles
      localStorage.setItem('userRoles', JSON.stringify(userRoles))
    },
    userTotalProjects: (state, userTotalProjects) => {
      state.userTotalProjects = userTotalProjects
      localStorage.setItem('userTotalProjects', userTotalProjects)
    },
    discounted: (state, discounted) => {
      state.discounted = discounted
      localStorage.setItem('discounted', JSON.stringify(discounted))
    },
    messagesUnread: (state, messagesUnread) => {
      state.messagesUnread = messagesUnread
    },
    accessToken: (state, accessToken) => {
      state.accessToken = accessToken
      localStorage.setItem('accessToken', accessToken)
    },
    refreshToken: (state, refreshToken) => {
      state.refreshToken = refreshToken
      localStorage.setItem('refreshToken', refreshToken)
    },
    swapRefreshToAccessToken: (state) => {
      state.accessToken = state.refreshToken
    },
    resetTokens: (state) => {
      state.userId = null
      state.userName = null
      state.discounted = false
      state.accessToken = null
      state.refreshToken = null
      localStorage.removeItem('userId')
      localStorage.removeItem('userName')
      localStorage.removeItem('discounted')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
    },
    store: (state, store) => {
      state.store = store
    },
    addOrder: (state, order) => {
      let storedOrders = state.orders.filter(function (storeOrder) {
        return storeOrder.id === order.id
      })
      if (storedOrders.length > 0) {
        storedOrders[0].amount += order.amount
      } else {
        state.orders.push(order)
      }
      localStorage.setItem('orders', JSON.stringify(state.orders))
    },
    removeOrder: (state, order) => {
      state.orders = state.orders.filter(function (storeOrder) {
        return storeOrder.id !== order.id
      })
      localStorage.setItem('orders', JSON.stringify(state.orders))
    },
    modifyOrder: (state, order) => {
      if (order.amount === 0) {
        state.orders = state.orders.filter(function (storeOrder) {
          return storeOrder.id !== order.id
        })
      } else {
        let storeOrder = state.orders.filter(function (storeOrder) {
          return storeOrder.id === order.id
        })[0]
        storeOrder.amount = order.amount
      }
      localStorage.setItem('orders', JSON.stringify(state.orders))
    },
    clearCart: (state) => {
      state.orders = []
      localStorage.removeItem('orders')
    },
    keepLoginBar: (state, keepLoginBar) => {
      state.keepLoginBar = keepLoginBar
    },
    previousRoute: (state, previousRoute) => {
      state.previousRoute = previousRoute
    },
    toRoute: (state, toRoute) => {
      state.toRoute = toRoute
    },
    redirected: (state, redireced) => {
      state.redirected = redireced
    },
    clearUpAutocomplete: (state) => {
      // do not remove the first two
      const pacContainers = document.getElementsByClassName('pac-container')
      if (pacContainers.length > 0) {
        let index = 0
        Array.prototype.forEach.call(pacContainers, function (el) {
          if (index > 1) {
            el.parentElement.removeChild(el)
          }
          index += 1
        })
      }
    },
    setScrollPosition: (state, path) => {
      var top = window.pageYOffset || document.documentElement.scrollTop
      var left = window.pageXOffset || document.documentElement.scrollLeft
      var payload = { path: path, x: left, y: top }
      state.scrollPositions = state.scrollPositions.filter(function (scrollPosition) {
        return scrollPosition.path !== payload.path
      })
      state.scrollPositions.push(payload)
    },
    activeScrollPosition: (state, path) => {
      let activeScrollPosition = state.scrollPositions.filter(function (scrollPosition) {
        return scrollPosition.path === path
      })
      if (activeScrollPosition.length > 0) {
        state.activeScrollPosition = activeScrollPosition[0]
      } else {
        state.activeScrollPosition = {
          path: path,
          x: 0,
          y: 0
        }
      }
    },
    moveToScrollPosition: (state) => {
      setTimeout(function () {
        window.scrollTo(state.activeScrollPosition.x, state.activeScrollPosition.y)
      }, 1)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js